import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import moment from 'moment';
import {toastr} from 'react-redux-toastr';
import ReactFileReader from 'react-file-reader';
import {apiRequest} from '../../utils/request';
import FileSaver from 'file-saver';
import 'react-table/react-table.css';
import ReactTable from 'react-table';
import {Aux, isNullEmptyOrWhitespace} from "../../constants";

class AttachmentView extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      selectedAttachment: null,
      isEditMode: false,
    };

    this.handleAttachmentFieldChange = this.handleAttachmentFieldChange.bind(this);
    this.handleSaveAttachment = this.handleSaveAttachment.bind(this);
    this.validateAttachment = this.validateAttachment.bind(this);
    this.handleCancelAttachment = this.handleCancelAttachment.bind(this);
    this.handleNewAttachment = this.handleNewAttachment.bind(this);
    this.handleSelectAttachment = this.handleSelectAttachment.bind(this);
  }

  handleAttachmentFieldChange(e) {
    if (e.base64 && e.base64 != '' && e.fileList.length == 1 && e.fileList[0].name != '') {
      if (e.fileList[0].size > 5000000) {
        toastr.error('File must be less than 5 Mb');
        this.setState({
          selectedAttachment: {
            ...this.state.selectedAttachment,
            fileContents: '',
            fileName: ''
          }
        });
      } else {
        this.setState({
          selectedAttachment: {
            ...this.state.selectedAttachment,
            fileContents: e.base64,
            fileName: e.fileList[0].name
          }
        });
      }
    } else {
      toastr.warning('Bad file');
    }
  }

  handleSaveAttachment() {
    let {selectedAttachment} = this.state;    
    
    this.props.onChange(selectedAttachment);
    
    this.setState({attachment: selectedAttachment, selectedAttachment: null, isEditMode: false});
  }

  validateAttachment(){
    let {selectedAttachment} = this.state;
    if(this.state.selectedAttachment){
      if(isNullEmptyOrWhitespace(selectedAttachment.fileName)){
        return {valid: false, error: ''};
      }
    }
    return {valid: true, error: ''};
  }

  handleCancelAttachment(){
    this.setState({selectedAttachment: null, isEditMode: false});
  }

  handleNewAttachment() {
    this.setState({
      selectedAttachment: {id: -1, fileName: ''},
      isEditMode: true
    });
  }

  handleSelectAttachment(ev, attachment) {
    ev.preventDefault();
    apiRequest(`/api/attachments/${attachment.id}`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while fetching attachment, error: ${x.error ? x.error : x.data.Message}`);
        } else {
          fetch(x.data.fileContents)
            .then(res => res.blob())
            .then(blob => FileSaver.saveAs(blob, x.data.fileName));
        }
      });
  }

  render() {
    let {visible, attachment} = this.props;
    const isValidAttachment = this.validateAttachment();
    let {selectedAttachment, isEditMode} = this.state;

    if (!visible) {
      return null;
    }

    return (<div>
      {!isEditMode &&
      <Aux>
      {attachment ?
          (<div className="form-group row">            
            <div className={"col-8 offset-2"}>
              {(attachment.id > 0 ?
              <a href="#" onClick={(e) => this.handleSelectAttachment(e, attachment)}>{attachment.fileName}</a>
              :
              <span>{attachment.fileName} (pending save)</span>)}
              
              <Button color="danger" className={"ml-1"} onClick={() => {
                this.setState({selectedAttachment: null, attachment: null, isEditMode: false}, ()=> {
                  this.props.onChange(null);
                });
              }}><i className="fa fa-minus"/>&nbsp;Remove logo</Button>
            </div>
          </div>) :    
          (<div className="form-group row">            
              <div className={"col-8 offset-2"}>
                <Button color="success" onClick={this.handleNewAttachment}><i
                    className="fa fa-plus"/>&nbsp;Set logo</Button>
            </div>
      </div>) 
      }</Aux> }

      {isEditMode &&
      (<div className="form-group row">
        <div className="col-8 offset-2">
          <div className="form-horizontal">
            <div className="form-group row">
              <div className="col-md-2">
                <ReactFileReader base64 multipleFiles={false}
                                 handleFiles={this.handleAttachmentFieldChange}>
                  <button className="btn">Upload</button>
                </ReactFileReader>
              </div>
              <div
                  className="col-md-10">{selectedAttachment.fileName ? selectedAttachment.fileName : 'Select file'}</div>
            </div>
            <div className="form-group row">
              <div className="col-md-8">
                {isValidAttachment.valid ?
                    <Button color="primary" onClick={this.handleSaveAttachment}
                            style={{marginRight: '10px'}}><i
                        className="fa fa-check"/>&nbsp;
                    </Button> :
                    <span className="text-danger">{isValidAttachment.error}</span>
                }
                <Button color="seconday" onClick={this.handleCancelAttachment}><i
                    className="fa fa-mail-reply"/>&nbsp;
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>)
      }
    </div>);
  }
}
AttachmentView.propTypes = {
  attachment: PropTypes.object,
  onChange: PropTypes.func.isRequired,  
  visible: PropTypes.bool.isRequired,
};

export default AttachmentView;
